import React from 'react';
import { Nav, Page, Content, Icon, PopUp } from '@beisen/chaos-ui';
import * as helper from '../../util/helper';
import * as UrlTools from '../../util/url';
import { addEnNavClassName } from '../../util/ui';
require('./AutoComplete.scss');

class SelectItem extends React.Component {
    constructor(props) {
        super(props);
        this.onTouchTap = this.onTouchTap.bind(this);
        this.state = {
            listHeight: window.innerHeight - 94
        };
    }

    onTouchTap(event) {
        event.preventDefault();
        let { onTouchTap } = this.props;
        onTouchTap && onTouchTap(event, this.props.data);
    }

    render() {
        let { data ,filter } = this.props;
        let activeFilter = data[1].replace(filter ,'<span class="active">' + filter + '</span>');
        return (
            <div className='autocom-item border-b'
                 onTouchTap={this.onTouchTap}
                 dangerouslySetInnerHTML={{ __html: activeFilter || data[1] }}
            >
            </div>
        );
    }
}

class PanelAutoComplete extends React.Component {
    constructor(props) {
        super(props);
        this.onChange = this.onChange.bind(this);
        this.tableItemClick = this.tableItemClick.bind(this);
        this.handleCancel = this.handleCancel.bind(this);
        this.handleClear = this.handleClear.bind(this);
        this.state = {
            TableData: []
        };
    }

    handleClear(event) {
        event && event.preventDefault && event.preventDefault();
        this.refs.in.blur();
        this.props.onClearValue && this.props.onClearValue();
    }

    searchData(value) {
        const { searchFailed } = this.props.translation;
        let params = {
            app: this.props.cmp_data.applicationName || BSGlobal.application
            ,dsName: this.props.datasourcename
            ,q: value
            ,metaObjName: this.props.cmp_data.metaObjectName || this.props.metaObjName
        };
        let TableData = this.state.TableData;
        let fetchUrl = helper.getAPI('AutoCompleteUrl');
        if(fetchUrl.indexOf('?') > -1) {
            fetchUrl  = fetchUrl + '&formState=' + this.props.formState;
        }else{
            fetchUrl  = fetchUrl + '?formState=' + this.props.formState;
        }



        const successCallBack = function(response) {
            TableData = response;
            this.setState({
                TableData,
                filter: value
            });
        }.bind(this);
        const conParam = UrlTools.getConnectSymbol(fetchUrl);
        fetchUrl = fetchUrl + conParam + UrlTools.serializeUrl(params);
        const failureCallBack = function(error) {
            let tipInfo = { message: error.message || searchFailed, type: 'error' };
            if (error.isOffLine) {
                error['type'] = 'error';
                tipInfo = error;
            }
            this.props.showTip(tipInfo);
        }.bind(this);

        if(this.props.cmp_data && this.props.cmp_data.datasourceurl) {
          fetchUrl = this.props.cmp_data.datasourceurl.replace(/{(\S*)}/g,value);
        }
        fetchUrl = helper.ajaxUrlCompletionInCachePage(fetchUrl);
        window.CommonFetch &&
            window.CommonFetch(fetchUrl, {}, successCallBack, failureCallBack);
    }

    onChange(event) {
        if (this.searchTimeout) {
            clearTimeout(this.searchTimeout);
        }
        let inVal = event.currentTarget.value;
        if (!inVal) {
            return false;
        }
        this.searchTimeout = setTimeout(event => {
           this.searchData(inVal , 0);
        },200);
    }

    handleCancel(event) {
        event && event.preventDefault && event.preventDefault();
        this.refs.in.blur();
        this.props.onCancel && this.props.onCancel(event);
    }

    tableItemClick(e, item) {
        e.preventDefault();
        this.refs.in.blur();
        this.props.onSubmit && this.props.onSubmit(e, item);
    }


	//设置壳子的导航对象并通知壳子更新导航
	setBoxHeader() {
        const { clear } = this.props.translation;
        let title = this.props.title;
		helper.generateHeaderConfig(function(headerConfig, setButton) {
			let config = Object.assign({}, headerConfig);
			//设置左侧按钮
			const left_item = [
				{
					callback: 'panelAutoCompleteCancel',
					control: true,
                    text: '',
                    type: 'back'
                },
                {
					icon: '',
					callback: 'panelAutoCompleteClear',
					control: true,
                    text: clear,
					type: 'text'
				}
			];
			config = setButton('left', left_item, config);
			//设置右侧按钮
			const right_item = [];
			config = setButton('right', right_item, config);
			//设置中间数据
			if (title) {
				config.titleItem = {
					text: title,
					icon: '',
					callback: '',
					control: false//代表是否相应用户事件
				};
			}
			return config;
		});
	}

	//组件销毁后获取前一个壳子的配置对象并通知壳子进行更新
	getPreHeaderConfig() {
		helper.clearHeaderConfig();
	}

	//注册壳子回调函数
	registCallback() {
		window.globalEventManager['panelAutoCompleteCancel'] = this.handleCancel.bind(this);
		window.globalEventManager['panelAutoCompleteClear'] = this.handleClear.bind(this);
	}

	//清除壳子回调函数
	clearCallback() {
		delete window.globalEventManager['panelAutoCompleteCancel'] && delete window.globalEventManager['panelAutoCompleteClear'];
	}

    componentDidMount() {
        if (helper.ifHidePopupNav() && this.props.pop_type !== 'searchList') {
            this.registCallback();
            this.setBoxHeader();
        }
    }

    componentWillUnmount() {
        if (helper.ifHidePopupNav() && this.props.pop_type !== 'searchList') {
            this.clearCallback();
            this.getPreHeaderConfig();
        }
    }

    render() {
        const { clear, cancel, search } = this.props.translation;
        const style = this.props.pop_type == 'searchList' ? { width: '85%', left: '15%' } : {};
        const animation = this.props.pop_type == 'searchList' ? 'right-slide-fade' : 'bottom-slide-fade';
        let navStyle = (helper.ifHidePopupNav() && this.props.pop_type !== 'searchList') ? { display: 'none' } : {};
        const enNavButtonClass = addEnNavClassName();
        return (
            <PopUp
                visible={this.props.visible}
                animation={animation}
                maskAnimation="fade"
                cls="autocomplete_popup"
                style={style}
                onClose={this.handleCancel}
                afterClose={this.props.afterClose}
            >
                <Page>
                    <Nav title={this.props.title} style={navStyle}>
                        <a href='javascript:;' className={enNavButtonClass} onTouchTap={this.handleClear} role='left' style={{ padding: '0 .08rem 0 .12rem' }}>{clear}</a>
                        <a href='javascript:;' className={enNavButtonClass} onTouchTap={this.handleCancel} role='right' style={{ padding: '0 .12rem .1rem 0' }}>{cancel}</a>
                    </Nav>
                    <Content>
                        <div className="search-user border-b">
                            <Icon icon="m-sys-sousuo" size='small' ref='searchIcon'  />
                            <input ref="in" className="search-input" placeholder={search} onChange={this.onChange} />
                        </div>
                        <div className='autocomplete-list' style={{ height: this.state.listHeight }}>
                            {
                                this.state.TableData.map((item,index) => {
                                    return <SelectItem key={index} data={item} filter={this.state.filter} onTouchTap={this.tableItemClick} />;
                                })
                            }
                        </div>
                    </Content>
                </Page>
            </PopUp>
        );
    }
}

export default PanelAutoComplete;



// WEBPACK FOOTER //
// ./src/components/Field_Components/AutoComplete/PanelAutoComplete.js